import React, { useMemo } from 'react';
import { Row, Col, Tag } from 'antd';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import colors from '../constants/Colors';

export const DATE_PRESETS_TYPES = {
  'This Week': 'This Week',
  'This Month': 'This Month',
  'This Quarter': 'This Quarter',
  'This Year': 'This Year',
  'Last 7 Days': 'Last 7 Days',
  'Last 30 Days': 'Last 30 Days',
  'All Time': 'All Time',
};

export const DATE_PRESETS = [
  DATE_PRESETS_TYPES['This Week'],
  DATE_PRESETS_TYPES['This Month'],
  DATE_PRESETS_TYPES['This Quarter'],
  DATE_PRESETS_TYPES['This Year'],
  DATE_PRESETS_TYPES['Last 7 Days'],
  DATE_PRESETS_TYPES['Last 30 Days'],
  DATE_PRESETS_TYPES['All Time'],
];

function DateFilter({
  datePreset,
  handlePreset,
  hideAllTime = false,
}) {
  const company = useSelector((state) => state.settings.company);
  const hasRedesign = company?.settings?.uxRedesignPt1;
  const selectedColor = hasRedesign ? colors.BLUE_700 : colors.ONTRACCR_RED;

  const presets = useMemo(() => {
    if (hideAllTime) {
      return DATE_PRESETS.filter((preset) => preset !== 'All Time');
    }
    return DATE_PRESETS;
  }, [hideAllTime]);

  return (
    <Row>
      {
        presets.map((preset) => (
          <Col key={preset}>
            <Tag
              color={datePreset === preset ? selectedColor : null}
              onClick={handlePreset ? () => handlePreset(preset) : undefined}
              className="analytics-date-preset-tag"
            >
              {preset}
            </Tag>
          </Col>
        ))
      }
    </Row>
  );
}

DateFilter.propTypes = {
  datePreset: PropTypes.string.isRequired,
  handlePreset: PropTypes.func.isRequired,
  hideAllTime: PropTypes.bool,
};

DateFilter.defaultProps = {
  hideAllTime: false,
};

export default DateFilter;
